/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";
import Accessibility from "./Accessibility";

/* Render Accessibility app into the pug template */
function render(props) {
  hydrate(<Accessibility {...props} />, document.getElementById("react"));
}

render(window.reactProps);
